import type { RootStateType } from '@/features/store';

/**
 * Получить флаг, отвечающий за показ разницы в сравнении
 */
const showDifferenceSelector = (state: RootStateType) =>
  state.comparison.isShowDifference;

export default showDifferenceSelector;
